var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.26129 0.21934C7.40174 0.359965 7.48063 0.550589 7.48063 0.74934C7.48063 0.948091 7.40174 1.13871 7.26129 1.27934L2.76129 5.77934C2.62067 5.91979 2.43004 5.99868 2.23129 5.99868C2.03254 5.99868 1.84192 5.91979 1.70129 5.77934L0.201292 4.27934C0.0688118 4.13717 -0.00331137 3.94912 0.000116847 3.75482C0.00354506 3.56052 0.0822571 3.37513 0.21967 3.23772C0.357083 3.10031 0.542468 3.02159 0.736769 3.01817C0.93107 3.01474 1.11912 3.08686 1.26129 3.21934L2.23129 4.18934L6.20129 0.21934C6.34192 0.0788896 6.53254 0 6.73129 0C6.93004 0 7.12067 0.0788896 7.26129 0.21934Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCheck);
export default __webpack_public_path__ + "static/media/blue-check.8c560593.svg";
export { ForwardRef as ReactComponent };